import { Box, CircularProgress, Fade, Stack } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import EdCategorySelector from "../components/JobPanels/EducationCategorySelector";
import {
  JobBg,
  JobInnerContainer,
  JobOuterContainer,
} from "../components/JobPanels/jobLayoutElements";
import {
  ResourceContainer,
  ResourceHeader,
} from "../components/JobPanels/ResourcePanel";
import {
  Color,
  EducationCategories,
  FontStyle,
  JobDisplays,
  MediaQuery,
  Slug,
} from "../constants";
import { JobFontSize } from "../utils/jobUtils";
import * as apiService from "../service/ApiService";
import EduPanelPlanner from "../components/Virtual/EduPanelPlanner";
import EducationCategorySelectorMobile from "../components/JobPanels/EducationCategorySelectorMobile";
import EduColumnBottom from "../components/Virtual/EduColumnBottom";
// import EduConversionFloat from "../components/EduConversionFloat";
import FullPanelFloat, {
  EduBackArrow,
  EduForwardArrow,
} from "../components/EduPanels/FullPanelFloat";
import ShortPostForwarder from "../components/EduPanels/ShortPostForwarder";
import { useNavigate } from "react-router-dom";
import { eduId_urlId } from "../utils/eduUtils";

const styles = {
  headerPanel: {
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    ...FontStyle.logo,
    fontSize: "36px",
    textAlign: "center",
    width: "100%",
  },
};

const rawSizes = {
  0: 576,
  1: 368,
  2: 320,
  3: 380,
};
const rowSpacing = 16;
const colSpacing = 24;

const sizingStyles = {
  0: {
    mid: "100%",
    left: "100%",
    right: "100%",
    maxWidth: `${rawSizes[0]}px`,
  },
  1: {
    mid: `${rawSizes[1]}px`,
    left: `${rawSizes[1]}px`,
  },
  2: {
    mid: `${rawSizes[2]}px`,
    left: `${rawSizes[2]}px`,
    right: `${rawSizes[2]}px`,
  },
  3: {
    mid: `${rawSizes[3]}px`,
    left: `${rawSizes[3]}px`,
    right: `${rawSizes[3]}px`,
  },
};

const txt1 =
  "<span> <b>Express Enthusiasm: </b>Show your enthusiasm for the role. Explain why you see yourself in the role and how you envision your best self in the position. </span>";

const TempPanel = () => {
  return (
    <ResourceContainer fullHeight={false}>
      <ResourceHeader
        title="Resources, Tips, and Templates for Writing an Amazing Cover Letter"
        subtitle="By Ex-Fortune 500 Recruiters"
      />
      <Box
        sx={{
          ...FontStyle.body,
          fontSize: JobFontSize.medium,
        }}>
        Hi
        <div dangerouslySetInnerHTML={{ __html: txt1 }}></div>
      </Box>
      {/* Bottom row with url + apply button */}
      {/* <Box sx={{ ...jobButtonStyle, width: "100%", maxWidth: "100%" }}>
        <DownloadTemplateWrapper href={JobDownloads.resumeTemplate}>
          Download Our Free Resume Template
        </DownloadTemplateWrapper>
      </Box> */}
    </ResourceContainer>
    // <Box
    //   sx={{
    //     ...FontStyle.body,
    //     width: "100%",
    //     borderRadius: JobDisplays.borderRadius,
    //     backgroundColor: JobDisplays.backgroundColor,
    //     boxShadow: JobDisplays.boxShadow,
    //     padding: JobDisplays.padding,
    //     cursor: "pointer",
    //     transition: "boxShadow 0.3s ease-in-out",
    //     position: "relative",
    //   }}>
    //   Hello
    // </Box>
  );
};

// :tag/id=:postid&ref=:refid
const EducationPage = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const urlTag = queryParameters.get("tag");
  const urlPostId = queryParameters.get("post");
  const urlRefId = queryParameters.get("ref");
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categoryIdx, setCategoryIdx] = React.useState(
    EducationCategories.includes(urlTag)
      ? EducationCategories.indexOf(urlTag)
      : 1
  );
  const mobile0 = useMediaQuery({ query: MediaQuery.mobile0 });
  const desktop1 = useMediaQuery({ query: MediaQuery.desktop1 });
  const desktop2 = useMediaQuery({ query: MediaQuery.desktop2 });
  const screenSizing = mobile0 ? 0 : desktop1 ? 1 : desktop2 ? 2 : 3;
  const numColumns = screenSizing === 0 ? 1 : screenSizing === 1 ? 2 : 3;
  const [targetIdx, setTargetIdx] = React.useState(null);
  const [posts, setPosts] = React.useState([]);
  const [hitBottomCount, setHitBottomCount] = React.useState(0); // update when scroll to bottom, will trigger reload
  const [urlPostData, setUrlPostData] = React.useState({
    eduId: urlPostId,
    active: urlPostId ? true : false,
  });
  const parentName = `e${screenSizing}`;
  const logEduClick = ({ clickType, clickId }) => {
    apiService.eduClick(dispatch, {
      ...auth.accountData,
      clickType: parentName + "-" + clickType,
      eduId: clickId,
    });
  };
  useEffect(() => {
    if (urlPostData.active) {
      return;
    }
    // set the url to be correct in format
    // Slug.education+/?tag=networking&post=2014
    let ext = "";
    ext += `?tag=${EducationCategories[categoryIdx]}`;
    if (targetIdx !== null) {
      ext += `&post=${eduId_urlId(posts[targetIdx].data.eduId)}`;
    }
    console.log("navigate to: ", Slug.education, ext);
    navigate({
      pathname: Slug.education + "/",
      search: ext,
    });
    // navigate({
    //   pathname: '/posts',
    //   search: `?${createSearchParams(params)}`,
    // });
  }, [categoryIdx, targetIdx, urlPostData]);

  return (
    <JobOuterContainer>
      <JobBg />
      <EduPanelPlanner
        posts={posts}
        setPosts={setPosts}
        categoryIdx={categoryIdx}
        hitBottomCount={hitBottomCount}
        urlPostData={urlPostData}
        setUrlPostData={setUrlPostData}
        setTargetIdx={setTargetIdx}
      />
      {(targetIdx !== null || urlPostData.active) && (
        <>
          <FullPanelFloat
            urlPostData={urlPostData}
            setUrlPostData={setUrlPostData}
            posts={posts}
            idx={targetIdx}
            setIdx={setTargetIdx}
          />
          <EduBackArrow posts={posts} setIdx={setTargetIdx} idx={targetIdx} />
          <EduForwardArrow
            posts={posts}
            setIdx={setTargetIdx}
            idx={targetIdx}
          />
        </>
      )}
      {/* {targetIdx !== null && (
        <EduConversionFloat post={posts[targetIdx]} setIdx={setTargetIdx} />
      )} */}
      <Stack direction="column" spacing={`${rowSpacing}px`}>
        <Stack
          direction="column"
          spacing={`${rowSpacing}px`}
          sx={{
            zIndex: 10,
            paddingTop: "24px",
            width: "100%",
            px: "24px",
            // width: mobile0
            //   ? "100%"
            //   : desktop1
            //   ? `${rawSizes[1] * 2 + colSpacing}px`
            //   : `${rawSizes[screenSizing] * 3 + colSpacing * 2}px`,
            // maxWidth: mobile0 ? `${rawSizes[0]}px` : "100%",
          }}>
          <Stack direction="column" sx={{ width: "100%" }}>
            <Box sx={styles.headerPanel}>Fetti University</Box>
          </Stack>
          {!mobile0 && (
            <EdCategorySelector
              categoryIdx={categoryIdx}
              setCategoryIdx={setCategoryIdx}
            />
          )}
          {mobile0 && (
            <EducationCategorySelectorMobile
              categoryIdx={categoryIdx}
              setCategoryIdx={setCategoryIdx}
            />
          )}
        </Stack>
        <JobInnerContainer
          mobile={mobile0}
          spacing={`${colSpacing}px`}
          sx={{ paddingTop: 0 }}>
          <Stack
            // left column
            spacing={`${rowSpacing}px`}
            sx={{
              width: sizingStyles[screenSizing].left,
              maxWidth: sizingStyles[screenSizing].maxWidth,
              minWidth: "",
              position: "relative",
            }}>
            {posts.length === 0 ? (
              <CircularProgress />
            ) : (
              <>
                {posts.map((post, idx) => {
                  if (idx % numColumns === 0) {
                    return (
                      <ShortPostForwarder
                        key={idx}
                        post={post}
                        setIdx={setTargetIdx}
                        idx={idx}
                        logEduClick={logEduClick}
                      />
                    );
                  } else {
                    return null;
                  }
                })}
                <EduColumnBottom
                  onHitBottom={() => setHitBottomCount((c) => c + 1)}
                  categoryIdx={categoryIdx}
                />
              </>
            )}
          </Stack>
          {!mobile0 && (
            <Stack
              // middle column
              sx={{
                width: sizingStyles[screenSizing].mid,
                maxWidth: sizingStyles[screenSizing].maxWidth,
                minWidth: "",
                position: "relative",
              }}
              direction="column"
              spacing={2}
              alignItems="center">
              {posts.length === 0 ? (
                <CircularProgress />
              ) : (
                <>
                  {posts.map((post, idx) => {
                    if (idx % numColumns === 1) {
                      return (
                        <ShortPostForwarder
                          key={idx}
                          post={post}
                          setIdx={setTargetIdx}
                          idx={idx}
                          logEduClick={logEduClick}
                        />
                      );
                    } else {
                      return null;
                    }
                  })}
                </>
              )}
            </Stack>
          )}
          {screenSizing > 1 && (
            <Stack
              // right column
              sx={{
                width: sizingStyles[screenSizing].right,
                maxWidth: sizingStyles[screenSizing].maxWidth,
                // minWidth: "300px",
              }}
              direction="column"
              spacing={2}
              alignItems="center">
              {posts.length === 0 ? (
                <CircularProgress />
              ) : (
                <>
                  {posts.map((post, idx) => {
                    if (idx % numColumns === 2) {
                      return (
                        <ShortPostForwarder
                          key={idx}
                          post={post}
                          setIdx={setTargetIdx}
                          idx={idx}
                          logEduClick={logEduClick}
                        />
                      );
                    } else {
                      return null;
                    }
                  })}
                </>
              )}
            </Stack>
          )}
        </JobInnerContainer>
      </Stack>
    </JobOuterContainer>
  );
};

export default EducationPage;
